import Api from './api';

// ---------------------------------------------------------------------------
// Item 2 — configuração dos alertas de segurança (API 2DO, api/security/alerts). JSON da API todo em minúsculo: normalizar aqui.
// Só GlobalAdministrator. O interruptor global só existe para o id 1 (canGlobalSwitch vem do servidor, que confere de novo).
// Sem async/await em arrow (babel do react-scripts 4): Promise chain.
// ---------------------------------------------------------------------------

function unwrap(result) {
  const body = result && result.data;
  if (!body || body.success === false) {
    const msg = body && body.errors && body.errors[0];
    throw new Error(msg || 'Falha ao consultar a configuração de alertas.');
  }
  return body;
}

const normalizeRule = (r) => ({
  enabled: (r?.enabled ?? true) !== false,
  severity: r?.severity ?? 'warning',
  perUserPerHour: Number(r?.peruserperhour ?? 10),
  perIpPerHour: Number(r?.peripperhour ?? 50),
  volumeMultiplier: Number(r?.volumemultiplier ?? 5), // 2b: volume_anomaly
});

export const normalizeSettings = (d) => {
  const rules = {};
  const src = d?.rules || {};
  Object.keys(src).forEach((k) => { rules[k] = normalizeRule(src[k]); });
  return {
    enabled: (d?.enabled ?? true) !== false,
    homeCountry: d?.homecountry ?? 'BR',
    notifyGlobalAdmins: d?.notifyglobaladmins === true, // desligado por padrão (27/09): só fixos + adicionais
    emails: d?.emails || [],
    fixedEmails: d?.fixedemails || [],
    rules,
    ruleKeys: d?.rulekeys || Object.keys(rules),
    severities: d?.severities || ['info', 'warning', 'critical'],
    limits: { perHourMin: Number(d?.limits?.perhourmin ?? 3), perHourMax: Number(d?.limits?.perhourmax ?? 10000), maxEmails: Number(d?.limits?.maxemails ?? 20), multiplierMin: Number(d?.limits?.multipliermin ?? 2), multiplierMax: Number(d?.limits?.multipliermax ?? 100) },
    globalEnabled: (d?.globalenabled ?? true) !== false,
    canGlobalSwitch: !!d?.canglobalswitch,
    // Cadência do e-mail de resumo: intervalo mínimo (minutos) entre e-mails; só o id 1 edita (canEditDigest vem do servidor, que confere de novo).
    digestCriticalMinutes: Number(d?.digestcriticalminutes ?? 30),
    digestNormalMinutes: Number(d?.digestnormalminutes ?? 240),
    canEditDigest: !!d?.caneditdigest,
    digestLimits: { min: Number(d?.digestlimits?.min ?? 5), criticalMax: Number(d?.digestlimits?.criticalmax ?? 240), normalMax: Number(d?.digestlimits?.normalmax ?? 720) },
  };
};

// Corpo do PUT no formato que a API espera (camelCase; a API aceita sem diferenciar maiúsculas).
const toBody = (s) => ({
  enabled: !!s.enabled,
  homeCountry: s.homeCountry,
  notifyGlobalAdmins: !!s.notifyGlobalAdmins,
  emails: s.emails || [],
  digestCriticalMinutes: Number(s.digestCriticalMinutes) || 30,
  digestNormalMinutes: Number(s.digestNormalMinutes) || 240,
  rules: Object.keys(s.rules || {}).reduce((acc, k) => {
    const r = s.rules[k];
    acc[k] = { enabled: !!r.enabled, severity: r.severity, perUserPerHour: Number(r.perUserPerHour) || 10, perIpPerHour: Number(r.perIpPerHour) || 50, volumeMultiplier: Number(r.volumeMultiplier) || 5 };
    return acc;
  }, {}),
});

const SecurityAlertService = {
  settings: () => Api.get('/security/alerts/settings').then((r) => normalizeSettings(unwrap(r).data || {})),
  saveSettings: (s) => Api.put('/security/alerts/settings', toBody(s)).then((r) => normalizeSettings(unwrap(r).data || {})),
  setGlobalSwitch: (enabled) => Api.put('/security/alerts/global-switch', { enabled: !!enabled }).then((r) => (unwrap(r).data || {}).globalenabled !== false),
};

export default SecurityAlertService;
